import { styled } from "@linaria/react"

import type { ReactNode } from "react"

export const HighlightMatches = ({ text, query }: {
  text: string
  query: string
}) => {
  if (!query) return <span>{text}</span>

  // First try: continuous substring
  const continuousRegex = new RegExp(`(${query})`, "gi")
  if (continuousRegex.test(text)) {
    const parts = text.split(continuousRegex)
    return (
      <span>
        {parts.map((part, index) =>
          part.toLocaleLowerCase() === query.toLocaleLowerCase() ? (
            <HighlightedSpan key={index}>{part}</HighlightedSpan>
          ) : (
            <span key={index}>{part}</span>
          )
        )}
      </span>
    )
  }

  // Fallback: fuzzy match (character by character, in order)
  const queryChars = query.toLocaleLowerCase().split("")
  const result: ReactNode[] = []
  let lastIndex = 0
  let qIndex = 0

  for (let i = 0; i < text.length; i++) {
    if (qIndex < queryChars.length && text[i].toLocaleLowerCase() === queryChars[qIndex]) {
      if (lastIndex < i) {
        // Non-highlighted chunk
        result.push(<span key={`n-${i}`}>{text.slice(lastIndex, i)}</span>)
      }
      // Highlighted chunk
      result.push(
        <HighlightedSpan key={`h-${i}`}>{text[i]}</HighlightedSpan>
      )
      qIndex++
      lastIndex = i + 1
    }
  }
  if (lastIndex < text.length) {
    // Trailing chunk
    result.push(<span key={`t-${lastIndex}`}>{text.slice(lastIndex)}</span>)
  }

  return <span>{result}</span>
}

const HighlightedSpan = styled.span`
  background-color: var(--highlighted-text-color);
`
